export default "__VITE_ASSET__3c91b07d__"